export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["REORDER"] = 1] = "REORDER";
    NotificationType[NotificationType["OUT_OF_STOCK"] = 2] = "OUT_OF_STOCK";
    NotificationType[NotificationType["ORDER_STATUS"] = 3] = "ORDER_STATUS";
})(NotificationType || (NotificationType = {}));
//# sourceMappingURL=notification-type.js.map